import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    bimesters: [],
    bimester: {}
  },
  mutations: {
    index(state, payload) {
      state.bimesters = payload
    },
    show(state,payload) {
      state.bimester = payload
    }
  },
  actions: {
    index ({commit}) {
      return axios.get(`${ENV.API_URL}/api/bimesters`).then((res) => {
        commit('index', res.data)
        return (res.data)
      })
    },
    show({commit}, payload) {
      return axios.get(`${ENV.API_URL}/api/bimesters/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({commit}, payload) {
      return axios.post(`${ENV.API_URL}/api/bimesters`, payload).then((res) => {
        commit('show', res.data)
      })
    },
    update({commit}, payload) {
      return axios.put(`${ENV.API_URL}/api/bimesters/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
      })
    }
  },
  getters: {
    bimesters: state => {
      return state.bimesters
    },
    bimester: state => {
      return state.bimester
    }
  },
  modules: {
  }
}
